import { useState, useEffect } from 'react';
import { useMedia } from 'react-use';
import { useTranslation } from 'react-i18next';
import { Button, Modal, Text, Stack } from '@hotjar/hotsauce';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';
import ModalImg from './assets/modal_img.jpg';

const MOBILE_BREAKPOINT = '(max-width: 960px)';
const UI_POSITION = 'Mobile Onboarding Modal';

export const MobileOnboardingModal = (): JSX.Element | null => {
  const isMobile = useMedia(MOBILE_BREAKPOINT);
  const [isDismissed, setIsDismissed] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(isMobile);
  const { t } = useTranslation();
  const { click: trackClick } = useTrack();
  const body = document.querySelector('body');

  const handleGoToInsightClick = () => {
    setIsModalOpen(false);
    setIsDismissed(true);
    trackClick('Go to Insights', UI_POSITION, {});
  };

  const handleCoursesLinkClick = () => {
    trackClick('Go to Courses', UI_POSITION, {});
  };

  useEffect(
    function handleResize() {
      const shouldOpenModal = !!isMobile && !isDismissed;
      setIsModalOpen(shouldOpenModal);
      if (!shouldOpenModal) setIsDismissed(true);
    },
    [isMobile],
  );

  useEffect(
    function handleScroll() {
      if (isModalOpen) {
        body?.classList.add('no-scroll');
      } else {
        body?.classList.remove('no-scroll');
      }

      return function removeClass() {
        body?.classList.remove('no-scroll');
      };
    },
    [isModalOpen, body?.classList],
  );

  return (
    <Modal
      size="s"
      contentLabel="Mobile modal"
      isOpen={isModalOpen && !isDismissed}
      hideCloseButton
      shouldCloseOnOverlayClick
      onClose={handleGoToInsightClick}
    >
      <Modal.Header title={t('activation:mobile-onboarding.modal.title')} />
      <img src={ModalImg} alt="" />
      <Modal.Body>
        <Text css={{ marginBottom: '0' }} as="p" textType="body1">
          {t('activation:mobile-onboarding.modal.description')}
        </Text>
      </Modal.Body>
      <Modal.Footer css={{ justifyContent: 'space-around' }}>
        <Stack direction="row">
          <Button onClick={handleGoToInsightClick} kind="secondary">
            {t('activation:mobile-onboarding.modal.cta')}
          </Button>
          <Button
            onClick={handleCoursesLinkClick}
            icon="open_new_window"
            href="https://learning.hotjar.com/courses/"
            as="a"
            isExternal
            kind="primary"
          >
            {t('activation:mobile-onboarding.modal.cta-link')}
          </Button>
        </Stack>
      </Modal.Footer>
    </Modal>
  );
};
